import { FontSize24Icon, FontSize32Icon } from '../icons';

const sizeIconMap = {
  '24px': FontSize24Icon,
  '32px': FontSize32Icon,
} as const;

export const replaceQuillSizeOptionIcons = (root: ParentNode = document) => {
  if (typeof document === 'undefined') return;

  const sizeButtons = root.querySelectorAll('.ql-size');

  sizeButtons.forEach(button => {
    const value = button.getAttribute('value') as keyof typeof sizeIconMap | null;

    if (!value) return;

    const iconSrc = sizeIconMap[value];
    if (!iconSrc) return;

    button.replaceChildren();

    const image = document.createElement('img');
    image.src = iconSrc;
    image.alt = `${value} font size`;
    image.width = 18;
    image.height = 18;
    image.className = 'pointer-events-none select-none';

    button.appendChild(image);
  });
};
